import { forwardRef } from 'react'
import { InputNumber } from 'antd'
import type { InputNumberProps } from 'antd'

import { getLocaleDecimalSeparator, parseDecimalInput } from '@/utils/common'

/**
 * AntD InputNumber preconfigured for decimal entry across locales:
 * - `inputMode="decimal"` so iOS shows a number pad with a decimal key
 * - `parser` accepts both "," and "." and normalises to a canonical "."
 *   (comma-decimal keyboards otherwise turn "55,5" into "555" on blur)
 * - `decimalSeparator` displays the value with the viewer's locale separator
 *
 * The stored value stays a canonical "." number — this only changes input and
 * presentation. Any default can be overridden by passing the same prop, and the
 * `ref` is forwarded to the underlying input so it stays a drop-in replacement.
 */
export const DecimalInput = forwardRef<HTMLInputElement, InputNumberProps>(
  function DecimalInput(props, ref) {
    return (
      <InputNumber
        ref={ref}
        inputMode="decimal"
        parser={parseDecimalInput}
        decimalSeparator={getLocaleDecimalSeparator()}
        {...props}
      />
    )
  }
)
